export default {
  title: 'Betaling',
  description: 'Alle transacties zijn beveiligd en versleuteld',
  show_more_payment_methods: 'Meer betaalmethoden tonen',
  express_checkout_divider: 'of',
};
